import { BinIcon } from "assets/icons";
import { useBoolean } from "hooks";
import { Button, Icon } from "ui";

import { DeleteCategoryModal } from "../modals";
import { DeleteCategoryProps } from "./DeleteCategory.types";

import styles from "./DeleteCategory.module.scss";

const DeleteCategory = ({ id, type, name, onDelete }: DeleteCategoryProps) => {
  const {
    value: isOpenModal,
    setTrue: onOpenModal,
    setFalse: onCloseModal
  } = useBoolean(false);

  return (
    <>
      <DeleteCategoryModal
        id={id}
        type={type}
        name={name}
        isOpen={isOpenModal}
        onClose={onCloseModal}
        onDeleteSuccess={onDelete}
      />

      <div className={styles["delete-category"]}>
        <Button
          variant="text-delete"
          icon={<Icon as={BinIcon} boxSize={24} color="#ff0033" />}
          onClick={onOpenModal}
        >
          Delete Category
        </Button>
      </div>
    </>
  );
};

export default DeleteCategory;
